export const questions = [
	{
		questionText: 'FlexSecure As A product of FPG Technologies Has How Many Sub-Products?',
		answerOptions: [
			{ answerText: '1', isCorrect: false },
			{ answerText: '4', isCorrect: false },
			{ answerText: '6', isCorrect: false },
			{ answerText: '8', isCorrect: true }
		]
	},
	{
		questionText: 'What year did Nigeria got their independence?',
		answerOptions: [
			{ answerText: '1967', isCorrect: false },
			{ answerText: '1977', isCorrect: false },
			{ answerText: '1960', isCorrect: true },
			{ answerText: '1961', isCorrect: false }
		]
	},
	{
		questionText: 'Who is Steve Jobs?',
		answerOptions: [
			{ answerText: 'Founder of Google', isCorrect: false },
			{ answerText: 'Founder of Apple', isCorrect: true },
			{ answerText: 'Rock Star Muscian', isCorrect: false },
			{ answerText: 'Founder of FPG Technologies', isCorrect: false }
		]
	},
	{
		questionText: 'Buhara is to APC while Goodluck is to?',
		answerOptions: [
			{ answerText: 'PDP', isCorrect: true },
			{ answerText: 'APC', isCorrect: false },
			{ answerText: 'APGA', isCorrect: false },
			{ answerText: 'LP', isCorrect: false }
		]
	}
];
